import { render, staticRenderFns } from "./DetailNavbar.vue?vue&type=template&id=4f0a0bd8&scoped=true"
import script from "./DetailNavbar.vue?vue&type=script&lang=js"
export * from "./DetailNavbar.vue?vue&type=script&lang=js"
import style0 from "./DetailNavbar.vue?vue&type=style&index=0&id=4f0a0bd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0a0bd8",
  null
  
)

export default component.exports